document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".features-tabs");
  if (!sections.length) return;

  sections.forEach((section) => {
    const items = section.querySelectorAll(".features-tabs__item");
    if (!items.length) return;

    const details = section.querySelector(".features-tabs__details");
    const ANIM_TIME = 450;

    const isDesktop = () => window.matchMedia("(min-width: 768px)").matches;

    const closeItem = (item) => {
      item.classList.remove("is-active");
      const btn = item.querySelector(".features-tabs__toggle");
      if (btn) btn.setAttribute("aria-expanded", "false");
    };

    const openItem = (item) => {
      item.classList.add("is-active");
      const btn = item.querySelector(".features-tabs__toggle");
      if (btn) btn.setAttribute("aria-expanded", "true");
    };

    const animateDetailsSwap = () => {
      if (!details) return;

      details.classList.add("is-changing");

      window.clearTimeout(details._swapTimeout);
      details._swapTimeout = window.setTimeout(() => {
        details.classList.remove("is-changing");
      }, ANIM_TIME);
    };

    const renderDetails = () => {
      if (!details) return;

      if (!isDesktop()) {
        details.innerHTML = "";
        return;
      }

      const activeItem = section.querySelector(".features-tabs__item.is-active") || items[0];
      if (!activeItem) return;

      const panelInner = activeItem.querySelector(".features-tabs__panel-inner");
      if (!panelInner) return;

      details.innerHTML = panelInner.innerHTML;
      animateDetailsSwap();
    };

    items.forEach((item) => {
      const btn = item.querySelector(".features-tabs__toggle");
      if (!btn) return;

      btn.addEventListener("click", () => {
        const isActive = item.classList.contains("is-active");

        items.forEach((i) => closeItem(i));
        if (!isActive) openItem(item);

        renderDetails();
      });
    });

    renderDetails();

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        renderDetails();
      }, 150);
    });
  });
});
